import {
  SET_CONFIRMATION_MODAL,
  CLOSE_CONFIRMATION_MODAL,
  SET_CONFIRMATION_MODAL_FORM_ERROR_MESSAGE,
  SET_CONFIRMATION_MODAL_FORM,
} from '../../ActionTypes'

export default (state = null, action = {}) => {
  switch (action.type) {
    case SET_CONFIRMATION_MODAL:
      return {
        ...action.modalProps,
      }
    case CLOSE_CONFIRMATION_MODAL:
      return null
    case SET_CONFIRMATION_MODAL_FORM_ERROR_MESSAGE:
      return {
        ...state,
        formErrors: action.formErrors,
      }
    case SET_CONFIRMATION_MODAL_FORM:
      return {
        ...state,
        form: action.form,
      }
    default:
      return state
  }
}
